import * as React from 'react'
import { Switch, Route } from 'react-router-dom'
import { SecureRoute } from 'react-route-guard'

import { Apis } from '../Apis'
import { SwaggerUI } from '../SwaggerUI'
import { Login } from '../Login'
import { Logout } from '../Logout'
import { Callback } from '../Callback'

import Guard from '../../services/Guard'


const routes = () => (
  <div>
    <Switch>
      <SecureRoute exact path="/" component={Apis} routeGuard={new Guard()} redirectToPathWhenFail='/login' />
      <SecureRoute exact path="/apis" component={Apis} routeGuard={new Guard()} redirectToPathWhenFail='/login' />
      <SecureRoute path="/apis/:id/swagger" component={SwaggerUI} routeGuard={new Guard()} redirectToPathWhenFail='/login' />
      <Route exact path="/login" component={Login} />
      <Route exact path="/logout" component={Logout} />
      <Route exact path="/callback" component={Callback} />
    </Switch>
  </div>
)

export default routes
